export default __webpack_public_path__ + "static/media/play-button.e4b67860.svg";